import { DigitalShowroomIcon } from "@/Utils/SVGExports/DigitalShowroomIcon";

export function DSBrandLogo() {
  return (
    <div className="tw-ml-[16px] tw-mr-[12px] tw-flex tw-flex-nowrap tw-items-center tw-gap-[10px] tw-overflow-hidden tw-text-nowrap tw-pb-[36px] tw-pt-[24px]">
      <span className="tw-flex">
        <DigitalShowroomIcon />
      </span>
      <h1 className="tw-m-0 tw-text-[16px]/[16px] tw-font-extrabold tw-text-[#000000]">
        digital
        <br />
        SHOWROOM
      </h1>
    </div>
  );
}
